import { createToast } from "./create-toast";
import app from "@/app";
import ToastController from "./toast-controller";
import lodash from "@/lodash";
const { curry, flowRight } = lodash;

const preset = curry(createToast)("ww-notification");
const show = (toast: HTMLElement) => document.body.appendChild(toast);

const warn = flowRight(show, preset("gwarning", "Warning:"));
const error = flowRight(show, preset("gerror", "Error:"));
const success = flowRight(show, preset("gsuccess", "Success:"));
const info = flowRight(show, preset("ginfo", "Info:"));

export default {
    warn, 
    error, 
    success, 
    info
}

ToastController.prototype.initialize = function(this: ToastController) {
    this.delay = 3000;
    this.fade = 2500;
}

app.register("toast", ToastController);
